import entityReducer from "./rolesEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
